class Device {
  constructor() {
    this.numpad = false
    this._volumeRange = 15
  }
  async _init() {
    return true
  }

  async properties(type = "playmore") {
    const { macAddress, ipAddress, serial, firmwareVersion, appVersion, brand, model } = await __._api.getProperties()

    const properties = {
      mac: macAddress,
      ip: ipAddress,
      serial: serial,
      firmware: firmwareVersion,
      software: appVersion,
      manufacturer: brand,
      product: model,
      type: type
    }

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  async baseUrl() {
    try {
      return JSON.parse(playmore.platform.getConfigAll("private")).url
    } catch (error) {
      return location.origin
    }
  }
  async getKeyMap() {
    return [
      // Controllers
      [21, "left"],
      [19, "up"],
      [22, "right"],
      [20, "down"],
      [23, "enter"],
      [4, "back"],
      [3, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [85, "toggle"],
      [-1, "stop"],
      [90, "fw"],
      [89, "rw"],
      [88, "prev"],
      [87, "next"],

      // TV
      [92, "ch_up"],
      [93, "ch_down"],
      [131, "tv"], //Register
      [-1, "subtitle"], //Register
      [-1, "list"], //Register
      [-1, "epg"],
      [136, "switch"],
      [133, "favorite"],

      // General
      [132, "info"],
      [-1, "settings"], //Register
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [-1, "source"], //Register
      [-1, "power"],
      [-1, "home"], //Register
      [-1, "refresh"], //Register

      [142, "red"],
      [141, "green"],
      [140, "yellow"],
      [139, "blue"],

      // Numpad
      [7, "numpad", 0],
      [8, "numpad", 1],
      [9, "numpad", 2],
      [10, "numpad", 3],
      [11, "numpad", 4],
      [12, "numpad", 5],
      [13, "numpad", 6],
      [14, "numpad", 7],
      [15, "numpad", 8],
      [16, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [134, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [64, "browser"],
      [-1, "cast"],
      [209, "movies"],
      [-1, "musics"],
      [-1, "usb"],
      [135, "shahid"]
    ]
  }
  async setName(name) {
    if (!name) return false
    playmore.device.setDeviceName(name)
    return true
  }
  async getName() {
    return playmore.device.getDeviceName()
  }

  /* Register Methods */
  async registerKeys() {
    return true
  }

  /* Volume Management */
  async volume(volume) {
    if (typeof volume !== "number") {
      const level = playmore.device.volume()
      return Math.round((level * 100) / this._volumeRange)
    } else {
      return playmore.device.volume(Math.round((this._volumeRange * volume) / 100))
    }
  }
  async mute(value) {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return playmore.device.mute(_$.true(value))
    return playmore.device.mute()
  }
  async maxVolume() {
    _$.vue.$on("volumeChanged", event => {
      if (event.detail > __.device.maxVolume) __.device.volume(__.device.maxVolume)
    })
    return true
  }

  /* Power Management */
  async getPowerState() {
    return "on"
  }
  async powerOn() {
    return playmore.device.tvOn()
  }
  async standBy() {
    return playmore.device.tvOff()
  }
  async reboot() {
    playmore.platform.setConfig("rebootByDevice", true)
    setTimeout(() => playmore.device.reboot(), 2000)
    return true
  }
  async clearData() {
    const promise = await _$.progress.create()

    /* Library Code */
    playmore.platform.closeActiveApps()
    await _$.sleep(1500)
    playmore.device.clearAppData()
    /* Library Code */

    _$.sleep(3000).then(() => promise.resolve())

    return promise.done
  }

  /* Soft AP */
  async getSoftAP() {
    const { password, ssid, status } = JSON.parse(playmore.device.getSoftAP())

    return {
      ssid: ssid,
      password: password,
      status: _$.true(status)
    }
  }
  async enableSoftAP(ssid, password) {
    playmore.device.enableSoftAP(ssid, password)
    await _$.sleep(1000)
    return true
  }
  async disableSoftAP() {
    playmore.device.disableSoftAP()
    await _$.sleep(1000)
    return true
  }
  async isSoftAPEnabled() {
    return playmore.device.isEnabledSoftAP()
  }
}

export default Device
